import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { AppContext } from "../../../Context/Context";
import './keywords.css';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import isURL from "validator/lib/isURL";


function KeywordEditForm(props) {
  const [weblinkError, SetweblinkError] = useState("");
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

  const [onPageError, SetonPageError] = useState("");
  const [loading, setLoading] = useState(false);
  const [CampaignList, SetCampaignList] = useState([]);
  const [SelectCampaignList, SetSelectCampaignList] = useState([]);
  const [KeywordName, SetKeywordName] = useState("");
  const [SearchEngine, SetSearchEngine] = useState("");
  const [Engineoptions, SetEngineoptions] = useState([]);
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [Countryoptions, SetCountryoptions] = useState([]);
  const [Stateoptions, SetStateoptions] = useState([]);
  const [CityOptions, SetCityOptions] = useState([]);
  const [countryValue, setCountryValue] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [DoaminSectionUrl, SetDoaminSectionUrl] = useState([]);
  const [Country, SetCountry] = useState("");
  const [State, SetState] = useState("");
  const [City, SetCity] = useState("");
  const [campaignerr, setCampaignerr] = useState("");
  const [engineerr, setEngineerr] = useState("");
  const [countryerr, setCountryerr] = useState("");
  const [stateerr, setStateerr] = useState("");
  const [cityerr, setCityerr] = useState("");
  const [cardmsg, setCardmsg] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [cardData, setCardData] = useState([]);
  const [campeditval, setCampeditval] = useState("");
  const [preferredUrl, setPreferredUrl] = useState("");
  const [preferredUrlErr, setPreferredUrlErr] = useState("");
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const navigate = useNavigate();
  let querystring = useParams();
  let plag_id = props.selectedKeyword;
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();



  const handleClose = () => {
    setOpen(false);
  };

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const handlestateoptions = async (Countrys = "", stateId) => {

    if (Countrys == "" || Countrys == null || !Countrys)
      return false;


    SetCountry(Countrys);

    const statedatavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}keywords/get_state_by_country/?country_id=${Countrys}`,
      {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
        return false;
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });

    if (statedatavalue?.data) {
      if (statedatavalue?.data?.states) {
        var Sections = [];
        statedatavalue.data.states.forEach((element) => {
          Sections.push({ label: element.state_name, value: element.id });
        });
        SetStateoptions(Sections);
        var stateData = Sections.find((option) => option.value === stateId);
        setStateValue(stateData);
      }
    }
  };
  const handleCityoptions = async (States = "", cityId) => {
    if (States == "" || States == null || !States) {
      return false;
    }

    SetState(States);

    const citydatavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}keywords/get_cities_by_state/?state_id=${States}`,
      {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
        return false;
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });

    if (citydatavalue?.data) {
      if (citydatavalue?.data?.cities) {
        var Sections = [];
        citydatavalue.data.cities.forEach((element) => {
          Sections.push({ label: element.city_name, value: element.id });
        });
        SetCityOptions(Sections);
        var cityData = Sections.find((option) => option.value === cityId);
        setCityValue(cityData);
      }
    }
  };
  const LoadAddFormFilterOptions = async (countryId, searchEngineId) => {
    SetSectionOptions([]);
    SetCountryoptions([]);
    SetEngineoptions([]);

    try {
      const doaminsectiondatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_domain_sections/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
          return false;
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (doaminsectiondatavalue?.data) {
        if (doaminsectiondatavalue?.data?.domain_sections) {
          SetDoaminSectionUrl(doaminsectiondatavalue.data.domain_sections);
          var Sections = [];
          doaminsectiondatavalue.data.domain_sections.forEach((element) => {
            Sections.push({ label: element.name, value: element.id });
          });
          SetSectionOptions(Sections);
        }
      }
    } catch (err) { }

    try {
      const countrydatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/get_countries/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
          return false;
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (countrydatavalue?.data) {
        if (countrydatavalue?.data) {
          var Sections = [];
          countrydatavalue.data.forEach((element) => {
            Sections.push({ label: element.name, value: element.id });
          });
          SetCountryoptions(Sections);
          var countryData = Sections.find((option) => option.value === countryId);
          setCountryValue(countryData);
        }
      }
    } catch (err) { }

    try {
      const countrydatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/get_countries/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
          return false;
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (countrydatavalue?.data) {
        if (countrydatavalue?.data) {
          var Sections = [];
          countrydatavalue.data.forEach((element) => {
            Sections.push({ label: element.name, value: element.id });
          });
          SetCountryoptions(Sections);
          var countryData = Sections.find((option) => option.value === countryId);
          setCountryValue(countryData);
        }
      }
    } catch (err) { }

    try {
      const enginedatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/search_engine_locale_list/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
          return false;
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (enginedatavalue?.data) {
        if (enginedatavalue?.data) {
          var Sections = [];
          enginedatavalue.data.forEach((element) => {
            if (element.id === searchEngineId) {
              SetSearchEngine({ label: element.name, value: element.id })
            }
            Sections.push({ label: element.name, value: element.id });
          });
          SetEngineoptions(Sections);
        }
      }
    } catch (err) { }
  };
  const GetDefaultSettings = async () => {
    setLoading(true);
    setCardData([]);
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}settings/keywordsettings_view/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
          return false;
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      setLoading(false);
      if (datavalue?.data) {
        setCardData(datavalue.data.keyword_settings);
        if (datavalue.data.keyword_settings == "Country") {
          SetState("");
          SetCity("");
        }
        else if (datavalue.data.keyword_settings == "State") {
          SetCity("");
        }
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const finalreportNow = async () => {
    var dataerr = 1;
    setCampaignerr("");
    SetweblinkError("");
    setEngineerr("");
    setCountryerr("");
    setStateerr("");
    setCityerr("");
    setPreferredUrlErr("");

    if (SelectCampaignList == "") {
      setCampaignerr("Please Select Campaign");
      dataerr = 2;
    }
    if (KeywordName == "") {
      setCampeditval("Please Enter Keyword");
      SetweblinkError("Please Enter Keyword");
      dataerr = 2;
    }
    if (preferredUrl != "") {
      if (!isURL(preferredUrl)) {
        setPreferredUrlErr("Please enter valid Preferred URL");
        dataerr = 2;
      }
    }
    if (dataerr == 1) {

      try {
        const Response = await axios.post(
          `${process.env.REACT_APP_API_URL}keywords/keyword_edit/`,
          {
            user_domain_id: esodata.domaindata.value.header_selected,
            campaign_id: `${SelectCampaignList.value}`,
            keyword_id: plag_id,
            keyword: KeywordName,
            preferred_url: preferredUrl
          },
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            return false;
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });
        if (
          Response?.data?.message ==
          "Keywords and associated details updated successfully"
        ) {
          props.setKeywordEditPopup(false);
          props.setsuccespopup(Response.data.message);
          props.setkeyWordAddPopup(true);
        }
      } catch (Response) {
        setCampaignerr("");
        SetweblinkError("");
        setEngineerr("");
        setCountryerr("");
        setStateerr("");
        setCityerr("");
        setCardmsg(Response?.response?.data?.error);
      }
    } else {
      return false;
    }
  };
  useEffect(() => {

    editDataval();
    GetCampaignData();
  }, []);
  const editDataval = async () => {
    SetCampaignList([]);

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}keywords/edited_keyword_data/?user_domain_id=${esodata.domaindata.value.header_selected}&keyword_id=${plag_id}`,
      {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
        return false;
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });

    if (datavalue?.data) {
      setCampeditval(datavalue.data)
      handlestateoptions(datavalue.data.country_id, datavalue.data.state_id);
      handleCityoptions(datavalue.data.state_id, datavalue.data.city_id)
      SetSelectCampaignList({
        label: datavalue.data.campaign_name,
        value: datavalue.data.campaign_id
      })
      SetKeywordName(datavalue.data.keyword)
      SetSearchEngine(datavalue.data.search_engine_id)
      SetCountry(datavalue.data.country_id)
      SetState(datavalue.data.state_id)
      SetCity(datavalue.data.city_id)
      setPreferredUrl(datavalue.data.preferred_url)

    }
  };
  const GetCampaignData = async () => {
    SetCampaignList([]);
    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}keywords/campaign_table/?user_domain_id=${esodata.domaindata.value.header_selected}`,
      {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
        return false;
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });

    if (datavalue?.data) {
      var Sections = [];
      datavalue.data.forEach((element) => {
        Sections.push({
          label: element.campaign_name,
          value: element.campaign_id,
        });
      });
      SetCampaignList(Sections);
    }
  };
  const onwebName = e => {

    SetKeywordName(e.target.value);
  }
  const handleBlur = (e) => {

    SetKeywordName(e.target.value);

  };

  const setCurrentCityValue = (e) => {
    setCityValue(e);
    SetCity(e.value);
  }

  function handleReset() {
    SetSelectCampaignList("");
    setCampeditval("");

  }

  return (
    <div className={`${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <div >
        <div>
          <span className="error-value">{onPageError}</span>

          <form className="dialog-input-form">


            <div>
              <div className="keyword-col1-fields">
                <div>
                  <label for="city" style={{ marginLeft: 'auto' }}>
                    Campaign Name :
                  </label>
                  <Select
                    name="campaign"
                    value={SelectCampaignList}
                    options={CampaignList}
                    onChange={(e) => { SetSelectCampaignList(e) }}
                    placeholder="Select Campaign"
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                    className="keyword-select-container"
                    classNamePrefix="addkeyword"
                  />
                </div>
                <div>
                  {" "}
                  <span className="error-value">{campaignerr}</span>
                </div>
              </div>
              <div className="keyword-col1-fields">
                <div>
                  <label>Keyword Names :</label>
                  <div>
                    <input
                      type="text"
                      className="dialog-input-text"
                      placeholder="Enter Keyword"
                      onChange={onwebName}
                      onBlur={handleBlur}
                      defaultValue={campeditval.keyword}
                      name="keywordname"
                    />
                  </div>
                </div>
                <div>
                  <span className="error-value">{weblinkError}</span>
                </div>
              </div>
              <div className="keyword-col1-fields">
                <div>
                  <label>Preferred URL :</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Preferred URL"
                      className="dialog-input-text"
                      value={preferredUrl}
                      defaultValue={campeditval.keyword}
                      onChange={(e) => setPreferredUrl(e.target.value)}
                    />
                  </div>
                </div>
                <div>
                  <span className="error-value">{preferredUrlErr}</span>
                </div>
              </div>
            </div>
            <div className="dialog-action-button" style={{ marginTop: "27px" }}>

              <button
                className="form_submit_btn"
                type="button"
                onClick={finalreportNow}
              >
                Submit
              </button>
              <button
                className="form_submit_btn"
                type="button"
                onClick={() => props.setKeywordEditPopup(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="form_submit_btn"
                onClick={handleReset}
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
      <CommonErrorAlert
        data={{
          apiopen: open,
          apiErrorMsg: cardmsg,
          isIconStyled: true
        }}
        closeAlert={handleClose} />
      <CommonErrorAlert
        data={{
          apiopen: apiopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: true
        }}
        closeAlert={apihandleClose} />
    </div>
  );
}

export default KeywordEditForm;
